'use client';

// npm packages
import React, { useEffect, useState } from 'react';

// components
import { cn } from '@/utils/cn';
import { useSelector } from 'react-redux';
import Button from '../Button';
import Text from '../Text';
import Icon from '../Icon';

// utils

function OrderCancelationRequest({ data, onClose, isCOD = true }) {
  const [openModal, setOpenModal] = useState(false);

  const { selectedOrder, type, isLoading, isOpenCancelRequestModal } =
    useSelector((state) => state.orders);

  useEffect(() => {
    if (isOpenCancelRequestModal) {
      setTimeout(() => {
        setOpenModal(true);
      }, 1);
    } else {
      setOpenModal(false);
    }
  }, [isOpenCancelRequestModal]);

  const handleClose = (closeState, orderCancelState) => {
    setOpenModal(closeState);
    setTimeout(() => {
      onClose(closeState, orderCancelState);
    }, 200);
  };

  return (
    <div
      className={cn(
        'w-full h-full bg-black/70 flex items-center justify-center opacity-0 -z-10 transition-all duration-300 fixed inset-0',
        {
          '!opacity-100 !z-[501]': openModal,
        },
      )}
    >
      <div className="w-full max-w-[480px] mx-8 lg:mx-0 px-16 lg:px-0 py-10 lg:py-24 relative rounded-[4px] lg:rounded-[12px] transition-all duration-[400ms]">
        <div className="mb-12">
          <Icon
            type="close"
            color="#fff"
            onClick={() => handleClose(false)}
            className="cursor-pointer ml-auto"
          />
        </div>
        <div className="bg-white p-24 rounded-xl shadow-product-slider-shadow">
          <Text
            type="sub_title"
            className="text-center text-18 lg:text-20 text-fire-chalk font-semibold leading-28 tracking-[0.36px] lg:tracking-[0.4px] mb-16"
          >
            Order Cancellation Request
          </Text>
          {isCOD ? (
            <Text
              type="paragraph"
              className="text-coarse-wool text-center text-14 lg:text-16 font-medium leading-20 tracking-[0.28px] lg:tracking-[0.32px] mb-24 px-10"
            >
              Are you sure you want to cancel this order?
            </Text>
          ) : (
            <>
              <Text
                type="paragraph"
                className="text-coarse-wool text-center text-14 lg:text-16 font-medium leading-20 tracking-[0.28px] lg:tracking-[0.32px] px-10"
              >
                Are you sure you want to request for cancellation?
              </Text>
              <Text
                type="paragraph"
                className="text-coarse-wool text-center text-14 lg:text-16 font-medium leading-20 tracking-[0.28px] lg:tracking-[0.32px] mb-24 px-10"
              >
                Once submitted, your request will be reviewed. If approved, your
                refund will be processed.
              </Text>
            </>
          )}

          <div className="flex flex-col w-full gap-4">
            <Button
              type="primary"
              className="w-full max-w-[200px] lg:max-w-[296px] mx-auto line-clamp-1 !bg-tealgreen !h-[40px] !py-0"
              onClick={() => handleClose(false, 'goBack')}
            >
              <Text
                type="span"
                className="text-center text-sm lg:text-base font-bold text-white"
              >
                Go Back
              </Text>
            </Button>
            <Button
              type="outline"
              className="w-full max-w-[200px] lg:max-w-[296px] !border-richcarmine mx-auto hover:bg-red-50 !h-[40px] !px-16 !py-0"
              onClick={() => handleClose(false, 'cancelOrder')}
            >
              <Text
                type="span"
                className="text-center text-14 lg:text-16 text-richcarmine font-bold leading-20 tracking-[0.28px] lg:tracking-[0.32px]"
              >
                Request Cancellation
              </Text>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderCancelationRequest;
